import { Module } from '../../../../../constants';
import { useTenantedApplicationConfig } from '../../../../../contexts';
import { buildIncludeParams } from '../../../../logic/buildIncludeParams';
import { ApplicationsSearchParams } from '../../types/ApplicationsSearchParams';
import { useApplications } from '../useApplications/useApplications';

const DEFAULT_INCLUDES = [
  'asset',
  'rates_and_fees',
  'quote',
  'directors',
  'business',
  'applicants',
];

export const useGetApplicationsQuery = (
  searchParams: ApplicationsSearchParams,
  definition: string,
) => {
  const config = useTenantedApplicationConfig();

  const includes = config.documents[definition].includes ?? DEFAULT_INCLUDES;
  const params = {
    ...(searchParams as Record<string, string>),
    ...buildIncludeParams(includes),
  };

  const { modules } = config.documents[definition];
  const { workflowDefinition, statusDefinition } =
    modules[Module.MiddleOffice].primaryWorkflow;

  return useApplications(
    params,
    {
      definitionName: definition,
      workflowName: workflowDefinition,
      statusDefinition,
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      staleTime: 10000,
    },
  );
};
